import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";

import { INBOX_CATALOGS } from "./model/inbox-copy.ts";
import { INBOX_ERROR_COPY } from "./model/inbox-error-copy.ts";

const inbox = () => import("./ui/sections/inbox-screen.tsx");

// D206 (ADR-006 §7): every screen and the sidebar entry need "outreach"; off, the screens are
// the not-found screen and the entry is absent, so the area does not exist for the organization.
export const inboxBrowserModule: BrowserModule = defineBrowserModule("inbox")
  .withErrorCopy(INBOX_ERROR_COPY)
  .withScreens({
    inbox: {
      path: "/inbox",
      title: phrase(INBOX_CATALOGS, "screenTitle"),
      layout: "app",
      flag: "outreach",
      load: inbox,
    },
    thread: {
      path: "/inbox/:threadId",
      title: phrase(INBOX_CATALOGS, "screenTitle"),
      layout: "app",
      flag: "outreach",
      load: inbox,
    },
  })
  .withNavigation([
    {
      id: "inbox",
      group: "outreach",
      label: phrase(INBOX_CATALOGS, "navInbox"),
      href: "/inbox",
      icon: "inbox",
      order: 210,
      flag: "outreach",
    },
  ]);
